import {EXPENSE_LIST, SHIPMENT_LIST, TRANSPORTATION_LIST} from "../Config/BillarApiUrl";
import {FormMixin} from "../../core/mixins/form/FormMixin";
import {DeleteMixins, ModalMixins} from "./billar/DeleteMixins";
import * as actions from '../Config/ApiUrl';
import {numberWithCurrencySymbol} from "../Helpers/Helpers";
import {urlGenerator} from "../Helpers/AxiosHelper"
import {Purpose} from "./FilterMixin";
import AppFunction from "../../core/helpers/app/AppFunction";
import {statusType} from "./FilterMixin";

export default {
	mixins: [FormMixin, Purpose, DeleteMixins, ModalMixins, statusType],
	data() {
		return {
			tableId: 'transportations-table',
			rowData: {},
			expenseSummery: {},
			preloader: false,
			isPurposeModalActive: false,
			numberWithCurrencySymbol,
			options: {
				url: TRANSPORTATION_LIST,
				name: this.$t('shipments'),
				filters: [
					{
						'title': this.$t('created'),
						'type': 'range-picker',
						'key': 'date',
						'option': ['today', 'thisMonth', 'last7Days', 'nextYear']
					},
					{
						'title': this.$t('date'),
						'type': 'range-picker',
						'key': 'tdate',
						'option': ['today', 'thisMonth', 'last7Days', 'nextYear']
					},
					{
						title: this.$t("status"),
						type: "checkbox",
						key: "status",
						option: [],
						permission: this.$can('show_all_data') ? true : false
					},
					// {
					// 	title: this.$t('purpose'),
					// 	type: 'drop-down-filter',
					// 	key: 'expense_purpose',
					// 	option: [],
					// }
				],
				columns: [
					{
						title: this.$t('date'),
						type: 'text',
						key: 'date_formatted',
					},
					{
						title: this.$t('driver_name'),
						type: 'object',
						key: 'driver',
						modifier: (driver) => driver ? driver.first_name + ' ' + driver.last_name : '-'
					},
					{
						title: this.$t('truck'),
						type: 'object',
						key: 'truck',
						modifier: truck => truck? truck.code : '-',
					},
					{
						title: this.$t('trailer'),
						type: 'object',
						key: 'trailer',
						modifier: trailer => trailer? trailer.code : '-',
					},
					{
						title: this.$t('client'),
						type: 'object',
						key: 'client',
						modifier: client => client? client.first_name + ' ' + client.last_name : '-',
					},
					{
						title: this.$t('customs_declaration'),
						type: 'text',
						key: 'customs_declaration',
					},
					{
						title: this.$t('shipment_details'),
						type: 'text',
						key: 'shipment_details',
					},
					{
						title: this.$t('destination_from'),
						type: 'text',
						key: 'destination_from',
					},
					{
						title: this.$t('destination_to'),
						type: 'text',
						key: 'destination_to',
					},
					{
						title: this.$t('departure_time'),
						type: 'text',
						key: 'departure_time_formatted',
					},
					{
						title: this.$t('arrival_time'),
						type: 'text',
						key: 'arrival_time_formatted',
					},
					{
						title: this.$t('containers'),
						type: 'custom-html',
						key: 'containers',
						modifier: (containers, row) => containers ? '<button onclick="Livewire.emit(\'showModal\', \'billar.transportation.containers-modal\', ' + row.id + ')" class="btn btn-sm btn-warning">' + containers.length + '</button>' : '-'
					},
					{
						title: this.$t('reference'),
						type: 'text',
						key: 'reference',
					},
					{
						title: this.$t('actions'),
						type: 'action'
					}
				],
				actions: [

					{
						title: this.$t('edit'),
						type: 'edit',
						modifier: () => this.$can("update_invoices"),
					},
					{
						title: this.$t('delivery_note'),
						type: 'delivery_note',
						modifier: (row) => row.shipment && this.$can("update_invoices"),
					},
					{
						title: this.$t('mark_as_delivered'),
						type: 'mark_as_delivered',
						modifier: (row) => row.shipment && !row.delivered_at && this.$can("update_invoices"),
					},
					{
						title: this.$t('delete'),
						type: 'delete',
						modifier: () => this.$can("delete_invoices"),
					},
				],
				rowLimit: 10,
				orderBy: 'desc',
				responsive: true,
				showHeader: true,
				showFilter: true,
				showSearch: true,
				showAction: true,
				tableShadow: true,
				actionType: 'dropdown',
				datatableWrapper: true,
				paginationType: 'pagination'
			},
		}
	},
	methods: {
		getListAction(rowData, actionObj) {
			if (actionObj.type === 'edit') {
				this.selectUrl = `transportations/show/${rowData.id}`;
				this.isModalActive = true;
			} else if (actionObj.type === 'delete') {
				this.selectUrl = `transportations/delete/${rowData.id}`;
				this.confirmationModalActive = true;
			} else if (actionObj.type === 'delivery_note') {
				window.open(urlGenerator('transportations/deliveryNote/' + rowData.id));
				// window.location.replace(urlGenerator('transportations/deliveryNote/' + rowData.id));
			}else if (actionObj.type === 'mark_as_delivered') {
				Livewire.emit('showModal', 'billar.transportation.mark-delivered-modal', rowData.id);
			}
		},
	}
	// this.$hub.$emit('reload-' + this.id);
}
